import i18n from "@/i18n";
import { showToast } from "@/lib/toastBus";

function showToastI18n(key, severity = "success", options) {
  showToast(i18n.t(key, options), severity);
}

export { showToastI18n };
